import { ISoundSettings } from '@GameStore/GameStoreSchema';

export const SOUND_SETTINGS_DEFAULTS: ISoundSettings = {
    reelStop: true,
    gambleShuffle: true,
    background: true,
    muteAll: false
};
